// The link from a player to its take in Audio Studio: the quest's editor path
// (the Tasks screen lives at /<slug>/<questId>/tasks, so the first two parts
// of the address are the quest) with the point, the field and the take —
// App.js opens the studio on ?studio=&field=&version= and selects that take.
// `draft` — the id of a Draft (tasks/drafts.js): the studio's Save then stores
// the edit INTO that Draft instead of as a take of the field, and `back`
// brings the person to this very screen afterwards.
export function studioHref(locationUuid, field, versionId, { draft = null } = {}) {
  if (typeof window === 'undefined' || !locationUuid || !versionId) return null;
  const parts = window.location.pathname.split('/').filter(Boolean);
  if (parts.length < 2) return null;
  const q = new URLSearchParams();
  q.set('location', locationUuid);
  q.set('studio', 'splice');
  q.set('field', field || 'description');
  q.set('version', String(versionId));
  if (draft) { q.set('draft', String(draft)); q.set('back', `${window.location.pathname}${window.location.search}`); }
  return `/${parts[0]}/${parts[1]}?${q.toString()}`;
}
